import { createAction } from 'redux-actions';
import { authFetch, authUpload } from '../AuthFetch';

export const changeFittingOrderId = createAction('CHANGE_FITTING_ORDERID');
export const changeFittingEventKey = createAction('CHANGE_FITTING_EVENT_KEY');
export const changeFittingActivePage = createAction('CHANGE_FITTING_ACTIVE_PAGE');

export const findFittingList = (payload, pagingData, serachData) => (
	(dispatch) => {
		if (payload && payload.orderId && !('' === payload.orderId)) {
			let searchDataUrl = '';
			if (serachData != null) {
				searchDataUrl = '&searchKeys=';
				for (let i = 0; i < serachData.searchKeys.length; i++) {
					searchDataUrl += serachData.searchKeys[i] + ',';
				}
				searchDataUrl += '&searchWord=' + serachData.searchWord;
			}
			let url = '/firefighter/fitting/' + payload.orderId + '/findFittingList?activePage=' + pagingData.activePage
				+ '&itemPerPage=' + pagingData.itemPerPage + searchDataUrl;
			authFetch('GET', url, null, (json) => {
				dispatch({
					type: 'FIND_FITTING_LIST',
					payload: json
				});
			});
		}
	}
);

export const openFittingOrdererModal = createAction('OPEN_FITTING_ORDERER_MODAL');
export const closeFittingOrdererModal = createAction('CLOSE_FITTING_ORDERER_MODAL');
export const clearFittingOrdererAlert = createAction('CLEAR_FITTING_ORDERER_ALERT');

export const findAllFirefighterTypes = () => (
	(dispatch) => {
		let url = '/firefighter/common/firefighterTypes';
		authFetch('GET', url, null, (json) => {
			dispatch({
				type: 'FIND_ALL_FIREFIGHTER_TYPES',
				payload: json
			});
		});
	}
);
export const changeOrdererValue = createAction('CHANGE_ORDERER_VALUE');
export const changeFittingRecordValue = createAction('CHANGE_FITTING_RECORD_VALUE');

export const addOrderer = (orderer, pagingData) => (
	(dispatch) => {
		let orderId = orderer.get('orderId');
		if (orderId && !('' === orderId)) {
			let url = '/firefighter/fitting/' + orderId + '/orderers';
			authFetch('POST', url, JSON.stringify(orderer), (json) => {
				dispatch({
					type: 'ADD_ORDERER',
					payload: json
				});
				dispatch(findFittingList({
					orderId: orderId
				}, pagingData));
			});
		} else {
			let url = '/firefighter/fitting/defaultValidateFail';
			let payload = { displayMessage: '驗證失敗:訂單編號不存在' };
			authFetch('PUT', url, JSON.stringify(payload), (json) => {
				dispatch({
					type: 'FITTING_DEFAULT_VALIDATE_FAIL',
					payload: json
				});
			});
		}
	}
);

export const deleteOrderer = (payload, deleteKey, pagingData) => (
	(dispatch) => {
		if (payload && payload.orderId && !('' === payload.orderId)) {
			let orderId = payload.orderId;
			let url = '/firefighter/fitting/' + orderId + '/orderers';
			authFetch('DELETE', url, JSON.stringify(deleteKey), (json) => {
				dispatch({
					type: 'DELETE_ORDERER',
					payload: json
				});
				dispatch(findFittingList(payload, pagingData));
			});
		}
	}
);

export const findOrderer = (payload, pk) => (
	(dispatch) => {
		if (payload && payload.orderId && !('' === payload.orderId)) {
			let url = '/firefighter/fitting/' + payload.orderId + '/orderers/' + pk.orderer_id;
			authFetch('GET', url, null, (json) => {
				dispatch({
					type: 'FIND_ORDERER',
					payload: json
				});
			});
		}
	}
);

export const editOrderer = (orderer, pagingData) => (
	(dispatch) => {
		let orderId = orderer.get('orderId');
		if (orderId && !('' === orderId)) {
			let url = '/firefighter/fitting/' + orderId + '/orderers/' + orderer.get('ordererId');
			authFetch('PUT', url, JSON.stringify(orderer), (json) => {
				dispatch({
					type: 'EDIT_ORDERER',
					payload: json
				});
				dispatch(findFittingList({
					orderId: orderId
				}, pagingData));
			});
		}
	}
);

export const findDetailsNeedBespoke = (payload) => (
	(dispatch) => {
		if (payload && payload.orderId && !('' === payload.orderId)) {
			let url = '/firefighter/fitting/' + payload.orderId + '/detailsNeedBespoke';
			authFetch('GET', url, null, (json) => {
				dispatch({
					type: 'FIND_DETAILS_NEED_BESPOKE',
					payload: json
				});
			});
		}
	}
);

export const openFittingRecordModal = createAction('OPEN_FITTING_RECORD_MODAL');
export const closeFittingRecordModal = createAction('CLOSE_FITTING_RECORD_MODAL');

export const findFittingRecord = (payload, pk) => (
	(dispatch) => {
		if (payload && payload.orderId && !('' === payload.orderId)) {
			let url = '/firefighter/fitting/' + payload.orderId + '/suits/' + pk.suit_id;
			authFetch('GET', url, null, (json) => {
				dispatch({
					type: 'FIND_FITTING_RECORD',
					payload: json
				});
			});
		}
	}
);

export const editFittingRecord = (fittingRecord, payload, pagingData) => (
	(dispatch) => {
		let suitId = fittingRecord.get('suit_id');
		if (payload && payload.orderId && !('' === payload.orderId)) {
			let url = '/firefighter/fitting/' + payload.orderId + '/suits/' + suitId;
			authFetch('PUT', url, JSON.stringify(fittingRecord), (json) => {
				dispatch({
					type: 'EDIT_FITTING_RECORD',
					payload: json
				});
				// dispatch(findFittingRecord({
				// 	orderId: payload.orderId
				// }, {
				// 		suit_id: suitId
				// 	}));
				dispatch(findFittingList({
					orderId: payload.orderId
				}, pagingData));
			});
		}
	}
);

export const deleteFittingRecord = (payload, pagingData) => (
	(dispatch) => {
		if (payload && payload.orderId && !('' === payload.orderId)) {
			let url = '/firefighter/fitting/' + payload.orderId + '/suits/' + payload.suitId;
			authFetch('DELETE', url, null, (json) => {
				dispatch({
					type: 'DELETE_FITTING_RECORD',
					payload: json
				});
				// dispatch(findFittingRecord({
				// 	orderId: payload.orderId
				// }, {
				// 		suit_id: payload.suitId
				// 	}));
				dispatch(findFittingList({
					orderId: payload.orderId
				}, pagingData));
			});
		}
	}
);

export const deleteFittingRecordByItem = (payload, pagingData) => (
	(dispatch) => {
		if (payload && payload.orderId && !('' === payload.orderId)) {
			let url = '/firefighter/fitting/' + payload.orderId + '/items/' + payload.itemId;
			authFetch('DELETE', url, null, (json) => {
				dispatch({
					type: 'DELETE_FITTING_RECORD_ITEM',
					payload: json
				});
				dispatch(findFittingRecord({
					orderId: payload.orderId
				}, {
						suit_id: payload.suitId
					}));
				dispatch(findFittingList({
					orderId: payload.orderId
				}, pagingData));
			});
		}
	}
);

export const findFittingBatchList = (payload, pagingData) => (
	(dispatch) => {
		if (payload && payload.orderId && !('' === payload.orderId)) {
			let url = '/firefighter/fitting/' + payload.orderId + '/findBatchList?activePage='
				+ pagingData.activePage + '&itemPerPage=' + pagingData.itemPerPage;
			authFetch('GET', url, null, (json) => {
				dispatch({
					type: 'FIND_FITTING_BATCH_LIST',
					payload: json
				});
			});
		}
	}
);
export const changeFittingBatchActivePage = createAction('CHANGE_FITTING_BATCH_ACTIVE_PAGE');

export const openFittingBatchModal = createAction('OPEN_FITTING_BATCH_MODAL');
export const closeFittingBatchModal = createAction('CLOSE_FITTING_BATCH_MODAL');

export const changeFittingBatchValue = createAction('CHANGE_FITTING_BATCH_VALUE');

export const addBatchItems = (batch, pagingData) => (
	(dispatch) => {
		let orderId = batch.get('orderId');
		if (orderId && !('' === orderId)) {
			let url = '/firefighter/fitting/' + orderId + '/addBatchItems';
			authFetch('POST', url, JSON.stringify(batch), (json) => {
				dispatch({
					type: 'ADD_BATCH_ITEMS',
					payload: json
				});
				dispatch(findFittingBatchList({
					orderId: orderId
				}, pagingData));
			});
		} else {
			let url = '/firefighter/fitting/defaultValidateFail';
			let payload = { displayMessage: '驗證失敗:訂單編號不存在' };
			authFetch('PUT', url, JSON.stringify(payload), (json) => {
				dispatch({
					type: 'FITTING_DEFAULT_VALIDATE_FAIL',
					payload: json
				});
			});
		}
	}
);

export const deleteBatchItems = (payload, deleteKey, pagingData) => (
	(dispatch) => {
		let orderId = payload.orderId;
		if (orderId && !('' === orderId)) {
			let url = '/firefighter/fitting/' + orderId + '/deleteBatchItems';
			authFetch('DELETE', url, JSON.stringify(deleteKey), (json) => {
				dispatch({
					type: 'DELETE_ORDERER',
					payload: json
				});
				dispatch(findFittingBatchList({
					orderId: orderId
				}, pagingData));
			});
		}
	}
);

export const findFittingDashboard = (payload) => (
	(dispatch) => {
		let orderId = payload.orderId;
		if (orderId && !('' === orderId)) {
			let url = '/firefighter/fitting/' + orderId + '/findFittingDashboard';
			authFetch('GET', url, null, (json) => {
				dispatch({
					type: 'FIND_FITTING_DASHBOARD',
					payload: json
				});
			});
		}
	}
);

export const uploadOrdererData = (payload, uploadFile) => (
	(dispatch) => {
		let orderId = payload.orderId;
		if (orderId && !('' === orderId)) {
			let formData = new FormData();
			formData.append('uploadfile', uploadFile);

			dispatch({
				type: 'BEFORE_UPLOAD_ORDERER_DATA'
			});

			let url = '/firefighter/fitting/' + orderId + '/uploadOrdererData';
			authUpload('POST', url, formData, (json) => {
				dispatch({
					type: 'AFTER_UPLOAD_ORDERER_DATA',
					payload: json
				});
				dispatch(findFittingList({
					orderId: orderId
				}, { activePage: 1, itemPerPage: 10 }));
			});
		} else {
			let url = '/firefighter/fitting/defaultValidateFail';
			let payload = { displayMessage: '驗證失敗:訂單編號不存在' };
			authFetch('PUT', url, JSON.stringify(payload), (json) => {
				dispatch({
					type: 'FITTING_DEFAULT_VALIDATE_FAIL',
					payload: json
				});
			});
		}
	}
);

export const uploadFittingData = (payload, uploadFile, forceUpload) => (
	(dispatch) => {
		let orderId = payload.orderId;
		if (orderId && !('' === orderId)) {
			let formData = new FormData();
			formData.append('uploadfile', uploadFile);

			dispatch({
				type: 'BEFORE_UPLOAD_ORDERER_DATA'
			});

			let url = '/firefighter/fitting/' + orderId + '/uploadFittingData/N';
			if ('Y' === forceUpload) {
				url = '/firefighter/fitting/' + orderId + '/uploadFittingData/Y';
			}
			authUpload('POST', url, formData, (json) => {
				dispatch({
					type: 'AFTER_UPLOAD_ORDERER_DATA',
					payload: json
				});
				dispatch(findFittingList({
					orderId: orderId
				}, { activePage: 1, itemPerPage: 10 }));
			});
		} else {
			let url = '/firefighter/fitting/defaultValidateFail';
			let payload = { displayMessage: '驗證失敗:訂單編號不存在' };
			authFetch('PUT', url, JSON.stringify(payload), (json) => {
				dispatch({
					type: 'FITTING_DEFAULT_VALIDATE_FAIL',
					payload: json
				});
			});
		}
	}
);

export const deleteFittingRecordByDuration = (payload) => (
	(dispatch) => {
		let orderId = payload.orderId;
		let duration = payload.duration;
		let type = payload.type;
		if (orderId && !('' === orderId)) {
			let url = '/firefighter/fitting/' + orderId + '/deleteFittingRecordByDuration/' + duration + '/' + type;
			authUpload('DELETE', url, JSON.stringify(payload), (json) => {
				dispatch({
					type: 'DELETE_BY_DURATION',
					payload: json
				});
			});
		} else {
			let url = '/firefighter/fitting/defaultValidateFail';
			let payload = { displayMessage: '驗證失敗:訂單編號不存在' };
			authFetch('PUT', url, JSON.stringify(payload), (json) => {
				dispatch({
					type: 'FITTING_DEFAULT_VALIDATE_FAIL',
					payload: json
				});
			});
		}
	}
);


// WEBPACK FOOTER //
// ./src/actions/fittingActions.js